import { render, staticRenderFns } from "./Subventionsbeitrag.vue?vue&type=template&id=92c4f44c"
import script from "./Subventionsbeitrag.vue?vue&type=script&lang=js"
export * from "./Subventionsbeitrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports